import React, {useRef} from 'react';
import {Box, Chip, InputAdornment, TextField, Typography} from '@mui/material';

const placeholders = [
    'externalId', 'payout', 'payoutCurrency', 'cps', 'conversionEventName', 'campaignId', 'campaignName',
    'trafficSourceId', 'trafficSourceName', 'deviceType', 'deviceVendor', 'deviceModel', 'browser', 'browserVersion',
    'os', 'osVersion', 'isp', 'ip', 'country', 'state', 'city', 'lang', 'trackingDomain', 'userAgent', 'referrerDomain',
    ...Array.from({length: 10}, (_, index) => `custom${index + 1}`)
];

export default function PostbackURLWithParams({label, name, register, errors, watch, setValue}) {
    const inputRef = useRef(null);
    const field = register(name, {
        required: 'Enter a postback URL.',
        pattern: {value: /^(http:\/\/www\.|https:\/\/www\.|http:\/\/|https:\/\/)[a-z0-9]+([-.]{1}[a-z0-9]+)*\.[a-z]{2,10}(:[0-9]{1,5})?(\/.*)?$/,
            message: 'Enter a valid HTTP or HTTPS postback URL.'}
    });
    const insertPlaceholder = placeholder => {
        const input = inputRef.current;
        if (!input) return;
        const start = input.selectionStart ?? input.value.length;
        const end = input.selectionEnd ?? start;
        const value = input.value.slice(0, start) + placeholder + input.value.slice(end);
        setValue(name, value, {shouldDirty: true, shouldValidate: true});
        input.focus();
        input.setSelectionRange(start + placeholder.length, start + placeholder.length);
    };

    return <Box sx={{display: 'grid', gap: 1.5, minWidth: 0}}>
        <TextField {...field} label={label} placeholder="e.g. https://example.com/postback?externalid={externalId}"
            inputRef={inputRef} error={!!errors[name]} helperText={errors[name]?.message}
            fullWidth size="small" slotProps={{inputLabel: {shrink: true},
                input: {startAdornment: <InputAdornment position="start">GET</InputAdornment>}}}/>
        <Typography sx={{fontSize: 12, color: 'text.secondary'}}>Click a token to insert it at the cursor.</Typography>
        <Box sx={{display: 'flex', flexWrap: 'wrap', gap: 0.75, minWidth: 0}}>
            {placeholders.map(name => {
                const placeholder = '{' + name + '}';
                return <Chip key={name} label={placeholder} variant="outlined" color="primary" size="small"
                    sx={{fontSize: 11, fontFamily: 'monospace', maxWidth: '100%'}}
                    onMouseDown={event => event.preventDefault()} onClick={() => insertPlaceholder(placeholder)}
                    disabled={!!watch(field.name)?.includes(placeholder)}/>;
            })}
        </Box>
    </Box>;
}
